export default __webpack_public_path__ + "static/end-game-win-8af5f237bbc3e7f9f3f73f436d52504b.png";